import React from 'react'
import { ClearAllFilters, RefreshIcon } from './atoms'
import useOfferListManualCooldown from './useOfferListManualCooldown'

const OfferListRefreshButton = ({
  onRefresh,
  onClearFilters,
  clearFiltersLabel
}) => {
  const { disabled, runWithCooldown } = useOfferListManualCooldown()

  return (
    <>
      <RefreshIcon
        disabled={disabled}
        onClick={() => runWithCooldown(onRefresh)}
      />
      <ClearAllFilters
        disabled={disabled}
        onClick={() => runWithCooldown(onClearFilters)}
      >
        {clearFiltersLabel}
      </ClearAllFilters>
    </>
  )
}

export default OfferListRefreshButton
